import type { BrandLegalLink, LegalLinkLanguage } from './types';

/** Swiss German has no legal pages of its own and reads the German ones */
const LANGUAGE_ALIASES: Record<string, LegalLinkLanguage> = { gsw: 'de' };

/**
 * The URL of a brand legal link for an app language (`de_CH`, `gsw_CH`, `en_US`, ...),
 * falling back to the English page when the brand has none in that language.
 */
export function resolveLegalLink(link: BrandLegalLink | undefined, language: string): string | undefined {
  if (link === undefined || typeof link === 'string') return link;

  const languageCode = language.split('_')[0];
  const legalLinkLanguage = LANGUAGE_ALIASES[languageCode] ?? (languageCode as LegalLinkLanguage);

  return link[legalLinkLanguage] ?? link.en;
}
